import Vue from 'vue';

const getClient = () => Vue.api.getClient('remotePreferences');

const initialState = {
  sessionState: {},
  localState: {},
  remoteState: {},
};

const mutations = {
  setSessionItem(state, { key, value }) {
    state.localState[key] = value;
  },
  setLocalItem(state, { key, value }) {
    state.localState[key] = value;
  },
  setRemoteItem(state, { key, value }) {
    state.remoteState[key] = value;
  },
};

const actions = {
  setSessionItem({ commit }, session) {
    try {
      commit('setSessionItem', session);
    } catch (err) {
      console.error(`error saving preference into session state: ${err}`);
    }
  },
  setLocalItem({ commit }, local) {
    try {
      commit('setLocalItem', local);
    } catch (err) {
      console.error('error saving preference into local state', err);
    }
  },
  async setRemoteItem({ commit, rootState }, remote) {
    try {
      const { key, value, excludeSync } = remote;
      const { session: { session } } = rootState;
      if (excludeSync !== true) {
        await getClient().setPreference(session.user.id, key, value);
      }
      commit('setRemoteItem', remote);
    } catch (err) {
      console.error('error saving remote preference', err);
    }
  },
};

const getters = {
  get: (state) => (key) => state.remoteState[key]
    || state.sessionState[key] || state.localState[key] || null,
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
